import ReCAPTCHA from './ReCAPTCHA';

export default ReCAPTCHA;
